import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router'

import { Layout } from '@/components/Layout'
import { Typography } from '@/components/Typography'
import { replaceStringVars } from '@/utils/functions/i18n/replaceStringVars'

import marqiiLogo from '@/assets/images/marqii.svg'
import { BrowserTitleKeys, useBrowserTitle } from '@/hooks/useBrowserTitle'
import styles from './styles.scss'

export function AuthLayout() {
  const currentYear = new Date().getFullYear().toString()
  const { t } = useTranslation()
  useBrowserTitle({ titleKey: BrowserTitleKeys.auth })

  return (
    <Layout className={styles.container}>
      <Layout.Content className={styles.content}>
        <img src={marqiiLogo} />

        <Outlet />
      </Layout.Content>

      <Layout.Footer className={styles.footer}>
        <Typography.Text type="secondary">
          {replaceStringVars({
            text: t('pages.auth.copyright'),
            vars: [currentYear],
          })}
        </Typography.Text>
      </Layout.Footer>
    </Layout>
  )
}
